import { useQuery, useMutation } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const getEmpDeductions = async ({
  companyCode,
  departmentCode = 0,
  deductionCode = 0,
  typeCode = 0,
  locationCode,
}) => {
  if (companyCode && locationCode) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpPayrollDeduction}?CompanyCode=${companyCode}&DepartmentCode=${departmentCode}&DeductionCode=${deductionCode}&TypeCode=${typeCode}&LocationCode=${locationCode}`
    );
    return data;
  }

  return [];
};

export const useGetEmpDeductionsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpPayrollDeduction],
    queryFn: () => getEmpDeductions(input),
    refetchOnWindowFocus: false,
  });
};

const createEmpDeduction = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.EmpDeductionCreation,
    input
  );
  return data;
};

export const useInsertEmpDeductionMutation = () => {
  return useMutation({
    mutationFn: createEmpDeduction,
  });
};

const updateEmpDeduction = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.EmpDeductionUpdate,
    input
  );
  return data;
};

export const useUpdateEmpDeductionMutation = () => {
  return useMutation({
    mutationFn: updateEmpDeduction,
  });
};
